<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M58.44 13.76a2 2 0 00-1.58-.76H24.64l-1.59-6.48A2 2 0 0021.11 5H17a1.5 1.5 0 000 3h3.32l3.2 13h-9.38l-1.59-6.48A2 2 0 0010.61 13H6.5a1.5 1.5 0 000 3h3.32l6.63 27a2 2 0 001.94 1.52h23.22A2 2 0 0043.55 43l1.58-6.47h7A2 2 0 0054.05 35l4.76-19.5a2 2 0 00-.37-1.74zM40.82 41.5H19.18L14.88 24h30.21zm10.5-8h-5.46l2.45-10a2 2 0 00-2-2.47h-19.7l-1.23-5h30.21zM38 47a6 6 0 106 6 6 6 0 00-6-6zm0 9a3 3 0 113-3 3 3 0 01-3 3zM22 47a6 6 0 106 6 6 6 0 00-6-6zm0 9a3 3 0 113-3 3 3 0 01-3 3z"/></svg>